<template>
  <div class="content-item">
    <el-tag v-if="useTag" v-bind="$attrs">{{ content }}</el-tag>
    <span v-else>{{ content }}</span>
  </div>
</template>

<script>
import { isFunction } from 'element-ui/src/utils/types'
export default {
  name: 'ContentItem',

  props: {
    // 内容
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: ''
    },

    // 过滤器钩子函数
    onFilter: {
      type: Function,
      default: value => value
    },

    // 类型
    useTag: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    // 返回展示的内容
    content() {
      let tempContent = this.isEmpty(this.value) ? ' - ' : this.value

      // 判断是否需要使用过滤器
      if (!isFunction(this.onFilter)) return tempContent
      tempContent = this.onFilter(tempContent)

      return tempContent
    }
  },

  methods: {
    isEmpty(value) {
      return value === undefined || value === null || value === ''
    }
  }
}
</script>

<style lang="scss" scoped>
.content-item {
  display: inline;
  span {
    word-break: break-word;
  }
}
</style>
